__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "talksoftWeb";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "17.3.12", () => (__webpack_require__.e(6443).then(() => (() => (__webpack_require__(46443))))));
			register("@angular/common", "17.3.12", () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(60316))))));
			register("@angular/core/primitives/signals", "17.3.12", () => (__webpack_require__.e(5689).then(() => (() => (__webpack_require__(8070))))));
			register("@angular/core/rxjs-interop", "17.3.12", () => (__webpack_require__.e(9074).then(() => (() => (__webpack_require__(49074))))));
			register("@angular/core", "17.3.12", () => (__webpack_require__.e(7580).then(() => (() => (__webpack_require__(37580))))));
			register("@angular/forms", "17.3.12", () => (__webpack_require__.e(2075).then(() => (() => (__webpack_require__(34456))))));
			register("@angular/router", "17.3.12", () => (__webpack_require__.e(1601).then(() => (() => (__webpack_require__(73982))))));
			register("@ngrx/effects", "17.2.0", () => (__webpack_require__.e(7876).then(() => (() => (__webpack_require__(17876))))));
			register("@ngrx/store", "17.2.0", () => (__webpack_require__.e(1439).then(() => (() => (__webpack_require__(11439))))));
			register("@ngx-translate/core", "14.0.0", () => (__webpack_require__.e(2978).then(() => (() => (__webpack_require__(597))))));
			register("@revspring-tech/portal-sdk", "0.0.16", () => (__webpack_require__.e(530).then(() => (() => (__webpack_require__(68149))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};